(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[345],{

/***/ 9590:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estimate/new",
      function () {
        return __webpack_require__(1621);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3786);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4480);
/* harmony import */ var _data_estimate_common_modal_atom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4457);
/* harmony import */ var _hooks_estimate_common_useSwitchingSelector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2903);
/* harmony import */ var _data_estimate_common_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7512);
/* harmony import */ var _data_estimate_common_defaultSetting_atom__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1245);
/* harmony import */ var _hooks_common_useReset__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7822);
/* harmony import */ var _components_estimate_common_header_EstimateHeader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1715);
/* harmony import */ var _components_estimate_common_selectCar_table_SelectCarTable__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5054);
/* harmony import */ var _components_estimate_common_optionAndSale_table_OptionTable__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(851);
/* harmony import */ var _components_estimate_common_tax_table_TaxTable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6888);
/* harmony import */ var _components_estimate_new_consignment_table_ConsignmentTable__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(631);
/* harmony import */ var _components_estimate_common_incidentalExpenses_table_IncidentalExpensesTable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(599);
/* harmony import */ var _components_estimate_common_paymentWay_table_PaymentWayTable__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1874);
/* harmony import */ var _components_estimate_common_paymentCharge_table_PaymentChargeTable__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8156);
/* harmony import */ var _components_estimate_common_customer_table_CustomerTable__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2759);
/* harmony import */ var _components_estimate_common_memoRecord_MemoRecordWrapper__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(1990);
/* harmony import */ var _components_estimate_common_estimateMark_table_EstimateMarkTable__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6996);
/* harmony import */ var _components_estimate_common_overallBar_OverallBar__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7503);
/* harmony import */ var _hooks_common_useDevice__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(9435);
/* harmony import */ var _components_estimate_common_overallBar_button_CompareOtherBankButton__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(9334);
/* harmony import */ var _components_estimate_common_overallBar_button_QuickReleaseCarButton__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(9561);
/* harmony import */ var _components_estimate_common_overallBar_button_FixedRightMobileButton__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(6168);
/* harmony import */ var _components_estimate_common_LoadArea__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(8345);
/* harmony import */ var _components_common_Loading__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(7773);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_29__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  grid-template-columns: repeat(2, auto);\n  gap: 8px;\n  width: 1024px;\n  height: auto;\n  padding: 0 20px;\n  overflow-x: overlay;\n\n  @media (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    width: auto;\n    padding: 0;\n    overflow-x: hidden;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(6, auto);\n  gap: 8px;\n\n  & > table:first-of-type,\n  & > table:nth-of-type(2),\n  & > table:nth-of-type(3),\n  & > table:nth-of-type(6),\n  & > table:nth-of-type(7),\n  & > table:nth-of-type(8),\n  & > table:nth-of-type(9),\n  & > table:nth-of-type(10),\n  & > table:last-of-type {\n    grid-column: span 2;\n  }\n\n  & > table:nth-of-type(4),\n  & > table:nth-of-type(5) {\n    grid-column: span 3;\n  }\n\n  & > div:first-of-type {\n    grid-column: span 6;\n  }\n  & > div:last-of-type {\n    grid-column: span 2;\n  }\n\n  @media (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n\n    & > table,\n    & > div > table {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





























const CompareTableArea = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(__webpack_require__.e(/* import() */ 281).then(__webpack_require__.bind(__webpack_require__, 1281)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1281)
            ]
    }
});
const OtherBankArea = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(__webpack_require__.e(/* import() */ 852).then(__webpack_require__.bind(__webpack_require__, 4852)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4852)
            ]
    }
});
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), (props)=>props.isLoading ? "none" : "grid");
const Body = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
/**
 * @param {BondDiscountRate[]} bondDiscountRateList 채권시세 목록
 * @param {Manager} salesManagerInfo 매니저 정보
 * @param {Memo[]} memoList 메모 목록
 * @param {DefaultSetting} defaultSetting 초기 설정값
 * @param {string} userNo 유저 번호
 * @param {any} loadData 불러온 데이터 (uri에 query parameter newEstimateNo 가 있을 때)
 * @param {ParsedUrlQuery} query query
 * @param {boolean} isLocal 로컬환경 여부
 *
 */ function NewPage(param) {
    let { bondDiscountRateList , salesManagerInfo , memoList , defaultSetting , userNo , loadData , query , isLocal  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_29__.useRouter)();
    // device
    const device = (0,_hooks_common_useDevice__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)();
    // state
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true);
    // reset
    (0,_hooks_common_useReset__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_data_estimate_common_common__WEBPACK_IMPORTED_MODULE_8__/* .tabState */ .Ns);
    // set
    const setDiscountRateList = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useSetRecoilState */ .Zl)(_data_estimate_common_defaultSetting_atom__WEBPACK_IMPORTED_MODULE_9__/* .bondDiscountRateListState */ .Am);
    const setManager = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useSetRecoilState */ .Zl)(_data_estimate_common_defaultSetting_atom__WEBPACK_IMPORTED_MODULE_9__/* .managerState */ .iH);
    const setMemoList = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useSetRecoilState */ .Zl)(_data_estimate_common_defaultSetting_atom__WEBPACK_IMPORTED_MODULE_9__/* .memoListState */ .EF);
    const setDefaultSetting = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useSetRecoilState */ .Zl)(_data_estimate_common_defaultSetting_atom__WEBPACK_IMPORTED_MODULE_9__/* .defaultSettingState */ .pt);
    const setUserNo = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useSetRecoilState */ .Zl)(_data_estimate_common_defaultSetting_atom__WEBPACK_IMPORTED_MODULE_9__/* .userNoState */ .M3);
    const setLoadData = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useSetRecoilState */ .Zl)(_data_estimate_common_common__WEBPACK_IMPORTED_MODULE_8__/* .loadDataInfo */ .KF);
    // const setAlert: SetterOrUpdater<Alert> = useSetRecoilState(alertState);
    // function
    const switchingSelector = (0,_hooks_estimate_common_useSwitchingSelector__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        fisrtSelector: _data_estimate_common_modal_atom__WEBPACK_IMPORTED_MODULE_6__/* .brandSelectorState */ .xC,
        secondSelector: _data_estimate_common_modal_atom__WEBPACK_IMPORTED_MODULE_6__/* .sustainableBgState */ .Uq
    });
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        // if (brandList?.length) {
        //   console.log('백엔드 => ', response);
        //   !query.newEstimateNo &&
        //     setTimeout(() => {
        //       switchingSelector(true, true);
        //     }, 500);
        // } else {
        //   alert('브랜드 목록을 가져올 수 없습니다.');
        //   // setAlert(
        //   //   (prev: Alert) =>
        //   //     prev && { ...prev, active: true, contents: '브랜드 목록을 가져올 수 없습니다.' }
        //   // );
        // }
        !query.newEstimateNo && setTimeout(()=>{
            //switchingSelector(true, true);
            switchingSelector(true, true);
        }, 500);
        setDiscountRateList(bondDiscountRateList);
        setManager(salesManagerInfo);
        setMemoList(memoList);
        setDefaultSetting(defaultSetting);
        userNo || isLocal ? setUserNo(userNo) : router.replace("/");
        loadData ? setLoadData(loadData) : setLoading(false);
        if (window.location.hostname !== "localhost") {
            // 새로고침 막기(조건 부여 가능)
            window.onbeforeunload = function() {
                // const yesData: boolean = !!infos.filter((data: SelectInfo<Brand>) => data.info).length;
                return true;
            };
            return ()=>{
                window.onbeforeunload = null;
            };
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        isLoading: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_header_EstimateHeader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                type: "newcar",
                query: query
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Body, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_selectCar_table_SelectCarTable__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        type: "newcar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_optionAndSale_table_OptionTable__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        optionType: "option",
                        type: "newcar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_optionAndSale_table_OptionTable__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        optionType: "sale",
                        type: "newcar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_tax_table_TaxTable__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        type: "newcar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_new_consignment_table_ConsignmentTable__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        type: "newcar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_incidentalExpenses_table_IncidentalExpensesTable__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        type: "newcar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_paymentWay_table_PaymentWayTable__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        tableNo: 1
                    }),
                    device === "mobile" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_overallBar_button_CompareOtherBankButton__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_paymentCharge_table_PaymentChargeTable__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CompareTableArea, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_customer_table_CustomerTable__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_memoRecord_MemoRecordWrapper__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_estimateMark_table_EstimateMarkTable__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        type: "newcar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OtherBankArea, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_overallBar_OverallBar__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                type: "newcar",
                device: device
            }),
            device === "mobile" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_overallBar_button_QuickReleaseCarButton__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                        type: "newcar",
                        query: query,
                        isMobile: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_overallBar_button_FixedRightMobileButton__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        type: "newcar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_estimate_common_LoadArea__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                type: "newcar",
                isPrice: (query === null || query === void 0 ? void 0 : query.price) === "",
                isSpec: (query === null || query === void 0 ? void 0 : query.spec) === "",
                setLoading: setLoading
            }),
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_common_Loading__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NewPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [876,636,33,774,888,179], function() { return __webpack_exec__(9590); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);